var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatEmoji({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smiley") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-6.628 0-12 5.373-12 12s5.372 12 12 12c6.627 0 12-5.373 12-12s-5.373-12-12-12zM20 9.812c0.828 0 1.5 0.896 1.5 2s-0.672 2-1.5 2-1.5-0.896-1.5-2 0.672-2 1.5-2zM11.925 9.825c0.828 0 1.5 0.896 1.5 2s-0.672 2-1.5 2-1.5-0.896-1.5-2 0.672-2 1.5-2zM15.875 23.312c-4.105 0-6.857-2.687-7.352-7.156h0.969c0.785 3.458 2.91 5.188 6.375 5.188s5.59-1.729 6.375-5.188h1c-0.494 4.47-3.262 7.156-7.367 7.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmoji);
export default __webpack_public_path__ + "static/media/ChatEmoji.33ef4c94326c4086cb536a91825863e0.svg";
export { ForwardRef as ReactComponent };